export default {"src":"/_next/static/media/podcast-profile-light.4e55f7c2.svg","height":100,"width":100};